import { connect } from 'react-redux';

import MealPrep from '~/Components/Global/MealPrep/MealPrep';

import { DATE_FORMAT } from '~/Redux/Constants';

import { createOrUpdateMealPrep } from '~/Redux/Modules/MealPreps';

const mapStateToProps = ({ DateRange, MealPreps }, props) => {
  const date = props.date ? props.date.format(DATE_FORMAT) : DateRange.start.format(DATE_FORMAT);
  return {
    isFetching: MealPreps.isFetching && (!MealPreps.actionDate || MealPreps.actionDate === date),
    mealPrep: MealPreps.data[date],
    currentDate: date,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateMealPrep: data => dispatch(createOrUpdateMealPrep(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MealPrep);
